var React = require('react');

function IconOpenFolderDash (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M192.116 75.961h-17.843V59.06a6.14 6.14 0 0 0-6.134-6.134H148.58a6.14 6.14 0 0 0-6.134 6.134 6.14 6.14 0 0 0 6.134 6.134h13.424v10.767H59.11c-2.166 0-4.193 1.162-5.239 2.951-.184.253-.324.53-.386.733a6.128 6.128 0 0 0-.381 1.197l-11.838 37.866V42.094l34.663-.064 21.369 21.369a6.091 6.091 0 0 0 4.337 1.797h25.006c3.382 0 6.134-2.752 6.134-6.135s-2.751-6.134-6.134-6.134h-22.466L82.803 31.553a6.1 6.1 0 0 0-4.349-1.797l-43.333.081A6.142 6.142 0 0 0 29 35.971V163.11a6.14 6.14 0 0 0 6.134 6.135H168.14a6.125 6.125 0 0 0 3.029-.802l.338-.193 1.406-4.5c.126-.207.225-.425.294-.649l24.521-78.432a2.44 2.44 0 0 0 .064-.248 6.063 6.063 0 0 0 .458-2.326 6.14 6.14 0 0 0-6.134-6.134zm-8.353 12.268l-21.495 68.747H42.156l21.492-68.747h120.115z"}));
}

IconOpenFolderDash.displayName = "IconOpenFolderDash";

IconOpenFolderDash.defaultProps = {"viewBox":"0 0 200 200"};

module.exports = IconOpenFolderDash;

IconOpenFolderDash.default = IconOpenFolderDash;
